define('lib/ExtendClassProperty',['require'],function (require) {

    return function (property) {
        var paramsList = _.tail(arguments);
        
        return function () {
            return _.extend.apply(_, [{}, _.result(this.constructor.__super__, property)].concat(paramsList));
        };
    };

});

